export default __webpack_public_path__ + "static/media/480_portfolio04-en-web.d512889c.png";